import { isEqual } from 'lodash/fp';

const PLOTS_MAX_COUNT = 500;

export const adaptPlotsAmount = <T>(data: T[]): T[] => {
    const { length } = data;

    if (length <= PLOTS_MAX_COUNT) return data;

    const delta = Math.ceil(length / PLOTS_MAX_COUNT);
    const selected: T[] = [];

    for (let i = 0; i < length; i += delta) {
        selected.push(data[i]);
    }

    const last = data[length - 1];
    const selectedLast = selected[selected.length - 1];

    if (!isEqual(last, selectedLast)) selected.push(last);

    return selected;
};
